import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map as IMap } from 'immutable';
import { FormattedMessage } from 'react-intl';
import { icons, LinkButton } from 'cstar-react-primitives/lib/redux-form';

import { undoItemRemove } from '../item/itemModule';
import {
    AMOUNT_FIELD,
    QUANTITY_FIELD,
    RECIPIENT_NAME_FIELD,
    IS_SELFBUY_FIELD
} from '../item/newItemForm';
import { isDecimal } from '../utils/numberUtils';

import notificationMessages from './notificationMessages';




export const NotifyUndoLink = (props) => {
    const { item, uid, undoItemRemove } = props;
    const linkProps = {
        onClick: () => undoItemRemove(item, uid),
        cashbotName: 'undo-remove'
    };
    return (
        <LinkButton {...linkProps}>
            <span className="notification-undo-remove__icon">{icons.UNDO_ICON}</span>
            <FormattedMessage {...notificationMessages.undoRemoveLinkText} />
        </LinkButton>
    );
};

NotifyUndoLink.defaultProps = {
    undoItemRemove: () => {}
};

NotifyUndoLink.propTypes = {
    item: PropTypes.instanceOf(IMap).isRequired,
    uid: PropTypes.string.isRequired,
    undoItemRemove: PropTypes.func
};

const mapDispatchToProps = {
    undoItemRemove
};

export const NotifyUndo = connect(
    null,
    mapDispatchToProps
)(NotifyUndoLink);


export const NotifyItemUndoRemove = (props) => {
    const { notification } = props;
    const item = notification.get('0').get('item');
    const cardValue = item.get(AMOUNT_FIELD);
    const isPriceDecimal = isDecimal(cardValue);
    const isSelfBuy = item.get(IS_SELFBUY_FIELD);
    let notificationMessage;
    if (!isSelfBuy && !isPriceDecimal) {
        notificationMessage = notificationMessages.undoRemoveContent;
    } else if (!isSelfBuy && isPriceDecimal) {
        notificationMessage = notificationMessages.undoRemoveContentDecimal;
    } else if (isSelfBuy && !isPriceDecimal) {
        notificationMessage = notificationMessages.undoRemoveContentSelfBuy;
    } else {
        notificationMessage = notificationMessages.undoRemoveContentSelfBuyDecimal;
    }

    const messageProps = {
        ...notificationMessage,
        values: {
            quantity: item.get(QUANTITY_FIELD),
            recipientName: item.get(RECIPIENT_NAME_FIELD),
            denomination: cardValue
        }
    };
    const undoProps = {
        item,
        uid: notification.get('uid')
    };
    return (
        <div className="notification-undo-remove">
            <NotifyUndo {...undoProps} />
            <h3 className="notification-undo-remove__message">
                <FormattedMessage {...messageProps} />
            </h3>
        </div>
    );
};

NotifyItemUndoRemove.propTypes = {
    notification: PropTypes.instanceOf(IMap).isRequired
};

export default NotifyItemUndoRemove;
